import { Button, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Input } from '@ibsys/kit';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useChangePassword } from '@/entities/profile';

export type ResetPasswordDialogPayload = { oldPassword: string; newPassword: string; confirmNewPassword: string };

export type ResetPasswordDialogProps = {
  close: () => void;
};

export const ResetPasswordDialog: FC<ResetPasswordDialogProps> = ({ close }) => {
  const { t } = useTranslation(['common', 'profile']);

  const { mutateAsync: changePassword, isPending: isSavingPassword } = useChangePassword();

  const { control, handleSubmit, reset } = useForm<ResetPasswordDialogPayload>({
    defaultValues: { oldPassword: '', newPassword: '', confirmNewPassword: '' },
  });

  const submit = handleSubmit(async ({ oldPassword, newPassword, confirmNewPassword }) => {
    // Поле формы `confirmNewPassword` маппится в контрактное `approvedPassword` бэка.
    await changePassword({ oldPassword, newPassword, approvedPassword: confirmNewPassword });
    reset();
    close();
  });

  return (
    <DialogContent className={'max-w-96'}>
      <DialogHeader>
        <DialogTitle>{t('profile:resetPassword')}</DialogTitle>
      </DialogHeader>
      <DialogDescription className={'flex flex-col gap-3 text-foreground'}>
        <Input type={'password'} label={t('profile:currentPassword')} control={control} name={'oldPassword'} />
        <Input type={'password'} label={t('profile:newPassword')} control={control} name={'newPassword'} />
        <Input type={'password'} label={t('profile:repeatPassword')} control={control} name={'confirmNewPassword'} />
      </DialogDescription>
      <DialogFooter className={'flex gap-3'}>
        <Button variant={'ghost'} onClick={close}>
          {t('cancel')}
        </Button>
        <Button onClick={submit} isLoading={isSavingPassword}>
          {t('save')}
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
